export default  {
  bindings: {
    propertyGroups: '<'
  },
  controller: 'propertyGroupListController',
  template: require('../views/property.group.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.group.list.component.js